/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".successmsg[_ngcontent-%COMP%]{text-align:center;width:100%;display:block;padding:15px 0;font-size:25px;font-weight:bolder}button.primary[_ngcontent-%COMP%]{color:#000}.tablediv[_ngcontent-%COMP%]{padding:4px 0}tbody[_ngcontent-%COMP%]{display:block;height:300px;overflow:auto}tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%], thead[_ngcontent-%COMP%]{display:table;width:100%;table-layout:fixed}thead[_ngcontent-%COMP%]{width:calc(100% - 1em)}"];
export { styles as styles };
